module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "search",
      "placeholder": "Search Workflow Attributes",
      "id": "example-search-input"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.org['curOrg']['role'] == '1' || _vm.org['curOrg']['role'] == 99) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": "/admin/workflowattribute/create"
    }
  }, [_vm._v("Add")])], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('data-table', {
    attrs: {
      "data": _vm.workflowAttributes,
      "columns": _vm.columns,
      "filter-key": _vm.searchQuery
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fa3d93d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/WorkflowAttributes/WorkflowAttributes.vue
// module id = 654
// module chunks = 1